exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-qualified {\n  background-color: #00ff8f;\n}\ntr td:nth-child(2),\ntr th:nth-child(2) {\n  padding-left: .5rem;\n}\n.pointer {\n  cursor: pointer;\n}\n.flip-list-move {\n  transition: transform .5s;\n}\n.no-move {\n  transition: transform 0s;\n}\n", ""]);

// exports
